import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import PatientCreateToolbar from 'components/patient/PatientCreateToolbar';
import PatientProfile from 'components/patient/PatientProfile';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class PatientCreate extends Component {
  constructor(props) {
    super(props);

    this.onCreate = this.onCreate.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onCreate(value) {
    const { history } = this.props;
    history.push(`/charts/${value}`);
  }

  onCancel() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    return (
      <Layout>
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Create Patient
          </title>
        </Helmet>
        <PatientCreateToolbar
          title="Create Patient"
          href="/charts"
        />
        <PatientProfile
          variant="create"
          onCreate={this.onCreate}
          onCancel={this.onCancel}
        />
      </Layout>
    );
  }
}

PatientCreate.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default PatientCreate;



// WEBPACK FOOTER //
// ./src/pages/charts/PatientCreate.js